import { makeStyles } from '@material-ui/core';

// Layout only — each section owns its own styles.
export const useStyles = makeStyles({
  content: {
    display: 'flex',
    gap: 24
  },
  previewColumn: {
    flex: '0 0 440px'
  },
  customizeColumn: {
    flex: 1
  },
  // 26px heading + 12px = the preview column's 30px header row + 8px, so the
  // first section top-aligns with the preview box.
  sections: {
    marginTop: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 24
  },
  plusIcon: {
    fontSize: 18,
    lineHeight: 1
  }
});
